/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseStatisticsAsJSONParser = 
/* #__PURE__ */ parsers.object([
    ['activeStudentAmount', codecNumber, 'active_student_amount'],
]);
export class CourseStatisticsAsJSON extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseStatisticsAsJSONParser.decode(input).map(res => new CourseStatisticsAsJSON(res));
    }
    static unsafeDecode(input) {
        return CourseStatisticsAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseStatisticsAsJSONParser.encode(data);
    }
    static schema() {
        return CourseStatisticsAsJSONParser.schema();
    }
}
